import { faCheckCircle, faExclamationCircle, faInfoCircle } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useApi } from 'ApiHooks'
import { useBlockUI } from 'Context/BlockUIContext'
import React, { useEffect, useState } from 'react'
import { Button, Container, Form, InputGroup, Modal } from 'react-bootstrap'

interface PropsModalCheckEmailUsuario {
    showModalRecuperarPassword: boolean
    setShowModalRecuperarPassword: (show: boolean) => void
    handleCloseModalCheckEmail: () => void
    usuario?: string
}

const ModalRecuperarPassword = ({ showModalRecuperarPassword, usuario, setShowModalRecuperarPassword, handleCloseModalCheckEmail }: PropsModalCheckEmailUsuario) => {

    let api = useApi()
    const { showBlock, hideBlock, blocking } = useBlockUI()

    const [emailInput, setEmailInput] = useState<string>('')
    const [showMensajeMailEnviado, setShowMensajeMailEnviado] = useState(false)
    const [showMensajeError, setShowMensajeError] = useState(false)

    async function recuperarPassword() {
        showBlock('Recuperando contraseña...')
        try {
            await api.recuperarPassword(emailInput).then((response) => {
                if (response?.StatusCode === 400) {
                    setShowMensajeError(true)
                }
                if (response?.statusCode === 200) {
                    setShowMensajeMailEnviado(true)
                }
            })
        } catch (error: any) {

        } finally {
            hideBlock()
        }
    }

    useEffect(() => {
        if (usuario!) {
            setEmailInput(usuario!)
        }

    }, [usuario])

    return (
        <>
            <Modal style={{
                backgroundColor: 'rgba(1,1,1,0.5)'
            }} show={showModalRecuperarPassword} dialogClassName="modal-check-email-usuario"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                animation={false}>
                <Modal.Header style={{ backgroundColor: '#528bf5ff', padding: '1rem', borderTopLeftRadius: '5px', borderTopRightRadius: '5px' }} closeButton={false}>
                    <Modal.Title style={{ color: 'white' }}>Recuperación de Usuario/Contraseña</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    {showMensajeMailEnviado ?
                        <div className="mt-3" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                            <FontAwesomeIcon color="#18b933ff" style={{ fontSize: 50, marginBottom: '5px', marginTop: '-20px' }} icon={faCheckCircle} />
                            <h5 className="text-center">Se ha enviado un mail con los pasos a seguir a su casilla de correo. Cualquier inconveniente comuniquesé con</h5>
                            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: 10 }}>
                                <p >Federico Bonet
                                    <br />
                                    (11)5352 - 5567
                                    <br />
                                    fbonet@banksa.com.ar
                                </p>
                            </div>
                        </div> : showMensajeError ? <>
                            <div className="mt-3" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                <FontAwesomeIcon color="#ff3434ff" style={{ fontSize: 50, marginBottom: '5px', marginTop: '-20px' }} icon={faExclamationCircle} />
                                <h5 className="text-center">No pudimos reestablecer su contraseña, por favor comuniquese con soporte.</h5>
                                <h4>sistemas@alpha2000.com.ar</h4>
                            </div>
                        </> : <div className="mt-3" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                            <FontAwesomeIcon color="#528bf5ff" style={{ fontSize: 50, marginBottom: '5px', marginTop: '-20px' }} icon={faInfoCircle} />
                            <h5 className="text-center">Ingrese el usuario para recuperar su contraseña</h5>
                        </div>}
                    <Container style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                        {(!showMensajeMailEnviado && !showMensajeError) && <Form.Group className="mb-4">
                            <InputGroup>
                                <Form.Group controlId="formBasicEmail">
                                    <Form.Control type="text" placeholder="Ingresar Usuario" value={emailInput} onChange={(e) => setEmailInput(e?.target?.value)} />
                                    <Form.Text className="text-muted">
                                        Por favor ingrese el usuario para recuperar su contraseña.
                                    </Form.Text>
                                </Form.Group>
                            </InputGroup>
                        </Form.Group>}
                        {showMensajeMailEnviado || showMensajeError ? <div>
                            <Button variant="success" onClick={() => {
                                setShowMensajeMailEnviado(false)
                                setEmailInput('')
                                setShowModalRecuperarPassword(false)
                                setShowMensajeError(false)
                            }}>
                                Aceptar
                            </Button>
                        </div> : <div>
                            <Button disabled={blocking || emailInput?.length === 0} onClick={() => recuperarPassword()}>Confirmar</Button>
                            <Button style={{ marginLeft: 10 }} variant="secondary" onClick={() => setShowModalRecuperarPassword(false)}>
                                Cerrar
                            </Button>
                        </div>}
                    </Container>
                </Modal.Body>
            </Modal>
        </>
    )
}

export default ModalRecuperarPassword